import { FormFieldType } from 'enums';

export const FORM_FIELD_FIXED_LENGTH: Partial<Record<FormFieldType, number>> = {
  [FormFieldType.FirstCardDigits]: 6,
  [FormFieldType.LastCardDigits]: 4,
  [FormFieldType.LastPhoneDigits]: 4,
};
